import { countries } from '@data/countries/countries';

export const getCountryFullText = (countryCode: string): string => {
  const country = countries.find(({ iso2 }) => iso2 === countryCode);
  return country ? country.name : '';
};
